import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "goods-spec-editor" }
const _hoisted_2 = { class: "editor-header" }
const _hoisted_3 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_4 = { class: "group-header" }
const _hoisted_5 = { class: "options-list" }

import { computed } from 'vue';

interface GoodsSpec {
  name: string;
  options: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'goods-spec-editor',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const specs = computed(() => props.modelValue || []);

const cloneSpecs = () => specs.value.map((item) => ({
  name: item.name || '',
  options: [...(item.options || [])],
}));

const updateSpecs = (nextSpecs: GoodsSpec[]) => {
  emit('update:modelValue', nextSpecs);
};

const addGroup = () => {
  const nextSpecs = cloneSpecs();
  nextSpecs.push({
    name: '',
    options: [''],
  });
  updateSpecs(nextSpecs);
};

const removeGroup = (groupIndex: number) => {
  const nextSpecs = cloneSpecs();
  nextSpecs.splice(groupIndex, 1);
  updateSpecs(nextSpecs);
};

const updateGroupName = (groupIndex: number, value: string) => {
  const nextSpecs = cloneSpecs();
  nextSpecs[groupIndex].name = value;
  updateSpecs(nextSpecs);
};

const addOption = (groupIndex: number) => {
  const nextSpecs = cloneSpecs();
  nextSpecs[groupIndex].options.push('');
  updateSpecs(nextSpecs);
};

const updateOption = (groupIndex: number, optionIndex: number, value: string) => {
  const nextSpecs = cloneSpecs();
  nextSpecs[groupIndex].options[optionIndex] = value;
  updateSpecs(nextSpecs);
};

const removeOption = (groupIndex: number, optionIndex: number) => {
  const nextSpecs = cloneSpecs();
  nextSpecs[groupIndex].options.splice(optionIndex, 1);
  if (nextSpecs[groupIndex].options.length === 0) {
    nextSpecs[groupIndex].options.push('');
  }
  updateSpecs(nextSpecs);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-text" }, [
        _createElementVNode("div", { class: "title" }, "商品规格"),
        _createElementVNode("div", { class: "desc" }, "不配置则按无规格商品处理；配置后用户每组规格选择一个，默认取第一项。")
      ], -1)),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        size: "small",
        onClick: addGroup
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("新增规格组", -1)
        ]))]),
        _: 1
      })
    ]),
    (specs.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "暂未配置规格"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specs.value, (group, groupIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: groupIndex,
        class: "spec-group"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            "model-value": group.name,
            placeholder: "请输入规格组名称，如：甜度",
            "onUpdate:modelValue": ($event: any) => (updateGroupName(groupIndex, $event))
          }, null, 8, ["model-value", "onUpdate:modelValue"]),
          _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            size: "small",
            onClick: ($event: any) => (removeGroup(groupIndex))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("删除组", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (option, optionIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${groupIndex}-${optionIndex}`,
              class: "option-item"
            }, [
              _createVNode(_component_el_input, {
                "model-value": option,
                placeholder: "请输入规格值，如：半糖",
                "onUpdate:modelValue": ($event: any) => (updateOption(groupIndex, optionIndex, $event))
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createVNode(_component_el_button, {
                type: "danger",
                text: "",
                onClick: ($event: any) => (removeOption(groupIndex, optionIndex))
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("删除", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]))
          }), 128))
        ]),
        _createVNode(_component_el_button, {
          size: "small",
          plain: "",
          onClick: ($event: any) => (addOption(groupIndex))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("新增选项", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]))
    }), 128))
  ]))
}
}

})